export const STORE_EDIT_SETTINGS = 'edit-settings';
export const SETTINGS_SET_OPTIONS = 'setOptions';
export const SETTINGS_SET_STATE = 'setState';
export const SETTINGS_UPDATE_NOTIF = 'updateNotifications';
export const SETTINGS_UPDATE_DISPLAY_SET = 'updateDisplaySettings';
export const SETTINGS_DISABLE_NOTIF = 'disableNotifications';
export const SETTINGS_GET_PREVIEW = 'getPreviewNotifications';
export const SETTINGS_SET_NOTIFICATIONS = 'setNotificationSettings';

export const MAX_DISTRICTS = 50;
